// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// TODO: Add your Firebase config object here
// You need to replace this with your actual Firebase project configuration
// Get this from Firebase Console > Project Settings > General > Your apps > Firebase SDK snippet > Config
const firebaseConfig = {
  apiKey: "AIzaSyCev1ol4ffCCnOPdNH_iI0rrx0le0UnWHc",
  authDomain: "shopbilling-sairamveterinary.firebaseapp.com",
  projectId: "shopbilling-sairamveterinary",
  storageBucket: "shopbilling-sairamveterinary.appspot.com",
  messagingSenderId: "319951011682",
  appId: "1:319951011682:web:7d9c91ff8cc390d43f363b"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

export default app;
